import { useEffect, useState } from 'react';

// Raccourcis clavier globaux.
// - "/" : focus le premier champ marqué [data-shortcut="search"] de la page
// - "Esc" : fermeture standard gérée par chaque composant (Modal, Dropdown AntD le font déjà)
// - "?" (Shift+/) : ouvre une modal listant les raccourcis (state local)
//
// Ignoré quand le focus est déjà dans un input/textarea (on ne capture pas "/" pendant la frappe).
//
// Retourne : { helpOpen, setHelpOpen }
const isEditableTarget = (el) => {
    if (!el) return false;
    const tag = (el.tagName || '').toLowerCase();
    if (['input', 'textarea', 'select'].includes(tag)) return true;
    if (el.isContentEditable) return true;
    return false;
};

const useKeyboardShortcuts = () => {
    const [helpOpen, setHelpOpen] = useState(false);

    useEffect(() => {
        const handler = (e) => {
            // "/" → focus search (sauf si on tape déjà dans un champ)
            if (e.key === '/' && !isEditableTarget(e.target) && !e.ctrlKey && !e.metaKey) {
                const searchInput = document.querySelector('[data-shortcut="search"] input, input[data-shortcut="search"]');
                if (searchInput) {
                    e.preventDefault();
                    searchInput.focus();
                }
                return;
            }
            // "?" → afficher l'aide
            if (e.key === '?' && !isEditableTarget(e.target) && !e.ctrlKey && !e.metaKey) {
                e.preventDefault();
                setHelpOpen(true);
            }
        };
        window.addEventListener('keydown', handler);
        return () => window.removeEventListener('keydown', handler);
    }, []);

    return { helpOpen, setHelpOpen };
};

export default useKeyboardShortcuts;
